import { S } from "./benchmark-box.styles";

export const BenchmarkBoxSkeleton = () => {
    return (
        <S.BenchmarkLoading>
            <S.BenchmarkLoadingIcon />
            <S.BenchmarkLoadingSkeleton variant="rectangular" />
        </S.BenchmarkLoading>
    );
};
